<template>
  <div id="appointEmergeModify">
    <div class="appointDiv-modify" @click="hideLicenseKeyBoard" v-if="formShow">
      <div class="cont1">
        <van-cell-group class="requried" style="width: calc(100vh - 34px);">
          <van-field
            v-model="params.areaValue"
            label="选择厂区"
            placeholder="请选择厂区"
            right-icon="arrow-down"
            readonly
            @click="areaShow = true"
            style="padding: 16px 0px;"
          />
        </van-cell-group>
      </div>
      <!-- 选择厂区 -->
      <van-action-sheet v-model="areaShow">
        <van-picker
          show-toolbar
          :columns="areaColumns"
          @cancel="onCancel"
          @confirm="onConfirmArea"
        />
      </van-action-sheet>
      <div class="cont4">
        <van-cell-group class="requried">
          <van-field
            v-model="params.unitName"
            label="运输单位"
            placeholder="请输入运输单位(限20个字符)"
          />
        </van-cell-group>
      </div>

      <!-- 选择业务大类 start -->
      <div class="cont1" v-if="type == 'add'">
        <van-cell-group class="requried" style="width: calc(100vh - 34px);">
          <van-field
            v-model="params.categoryValue"
            label="业务大类"
            placeholder="请选择"
            right-icon="arrow-down"
            readonly
            @click="categoryShow = true"
            style="padding: 16px 0px;"
          />
        </van-cell-group>
      </div>
      <van-action-sheet v-model="categoryShow">
        <van-picker
          show-toolbar
          :columns="categoryColumns"
          @cancel="onCancel"
          @confirm="onConfirmCategory"
        />
      </van-action-sheet>
      <!-- 选择业务大类 end -->

      <template v-if="params.category == 3">
        <p style="padding: 0 15px;font-weight: bold;">卸货业务</p>
        <div class="cont4">
          <van-cell-group class="requried">
            <van-field
              v-model="params.discharge_order_code"
              label="单据编号"
              placeholder="请输入单据编号"
            />
          </van-cell-group>
        </div>
        <div class="cont4">
          <van-cell-group class="requried">
            <van-field
              v-model="params.discharge_delivery_unit"
              label="收货单位"
              placeholder="请输入收货单位"
            />
          </van-cell-group>
        </div>
        <!-- 卸载业务选择 -->
        <div class="cont1" v-if="params.areaValue !== ''">
          <van-cell-group class="requried" style="width: calc(100vh - 34px);">
            <van-field
              v-model="params.dischargeBusinessValue"
              label="选择业务"
              placeholder="请选择业务"
              right-icon="arrow-down"
              readonly
              @click="dischargeBusinessShow = true"
              style="padding: 16px 0px;"
            />
          </van-cell-group>
          <!-- :default-index="getDefaultIndex" -->
        </div>

        <!-- 选择业务 -->
        <van-action-sheet v-model="dischargeBusinessShow">
          <van-picker
            show-toolbar
            :columns="dischargeBusinessColumns"
            @cancel="onCancel"
            @confirm="onConfirmDischargeBusiness"
          />
        </van-action-sheet>
        <!-- 卸载业务选择 -->

        <!-- 卸货子业务线 -->
        <div class="cont2" style="display: block;" v-if="params.dischargeBusinessValue !== ''">
          <div>
            涉及{{ dischargeBusinessType === 1 ? "产品线(可多选)" : "业务子类(单选)"
            }}<span style="color: red;">*</span>
          </div>
          <div
            :class="item.selected === true ? 'tabblk-active' : 'tabblk'"
            v-for="(item, index) in dischargeProLineColumms"
            :key="index"
            @click="SelectDischargeProLine(item, index, dischargeBusinessType)"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- 卸货子业务线 -->

        <!-- 卸货车辆类型 -->
        <div class="cont1">
          <van-cell-group class="requried" style="width: calc(100vh - 34px);">
            <van-field
              v-model="params.dischargeVehicleValue"
              label="车辆类型"
              placeholder="请选择车辆类型"
              right-icon="arrow-down"
              readonly
              @click="dischargeVehicleShow = true"
              style="padding: 16px 0px;"
            />
          </van-cell-group>
        </div>
        <!-- 卸货车辆类型 -->
        <van-action-sheet v-model="dischargeVehicleShow">
          <van-picker
            show-toolbar
            :columns="dischargeVehicleColumns"
            @cancel="onCancel"
            @confirm="onConfirmDischargeVehicle"
          />
        </van-action-sheet>
        <!-- 卸货车辆类型 -->

        <div class="cont1" v-if="params.dischargeVehicleValue !== ''">
          <div class="left">预约时间<span style="color: red;">*</span></div>
          <div :style=" params.dischargeTimeValue == '请选择预约时间' ? 'flex: 2.1;color: #969799;' : 'flex: 2.1;' " @click="selectAppointTime2" >
            <div v-if="isMultipleTime">
              <div class="inline" :style="Number(params.bookingState) == 2 ? 'color: #666;' : ''" >
                <div v-if="params.dischargeTimeValue == '请选择预约时间'">
                  {{ params.dischargeTimeValue }}
                </div>
                <div
                  v-else-if="params.discharge_multiple_time"
                  :style="{
                    'line-height':
                      params.discharge_multiple_time.length > 1 ? '34px' : '54px',
                    'margin-top': params.discharge_multiple_time.length > 1 ? '10px' : '0px'
                  }"
                >
                  <div v-for="(item, index) in params.discharge_multiple_time" :key="index">
                    {{ params.dischargeTimeValue }} {{ item.beginTime }}至{{ item.endTime }}
                  </div>
                </div>
              </div>
            </div>
            <span v-else :style="Number(params.bookingState) == 2 ? 'color: #666;' : ''" >
              {{ params.dischargeTimeValue == "请选择预约时间" ? params.dischargeTimeValue : `${params.dischargeTimeValue} ${params.discharge_begin_time} 至 ${params.discharge_end_time}` }}
            </span>
          </div>
          <div class="right"></div>
        </div>
      </template>

      <template>
        <p style="padding: 0 15px;font-weight: bold;">
          {{ params.category == 2 ? "卸货" : "装货" }}业务
        </p>

        <div class="cont4">
          <van-cell-group class="requried">
            <van-field
              v-model="params.order_code"
              label="单据编号"
              placeholder="请输入单据编号"
            />
          </van-cell-group>
        </div>

        <div class="cont4">
          <van-cell-group class="requried">
            <van-field
              v-model="params.delivery_unit"
              label="收货单位"
              placeholder="请输入收货单位"
            />
          </van-cell-group>
        </div>

        <div class="cont1" v-if="params.areaValue !== ''">
          <van-cell-group class="requried" style="width: calc(100vh - 34px);">
            <van-field
              v-model="params.businessValue"
              label="选择业务"
              placeholder="请选择业务"
              right-icon="arrow-down"
              readonly
              @click="businessShow = true"
              style="padding: 16px 0px;"
            />
          </van-cell-group>
        </div>

        <!-- 选择业务 -->
        <van-action-sheet v-model="businessShow">
          <van-picker
            show-toolbar
            :columns="businessColumnsComputed"
            @cancel="onCancel"
            @confirm="onConfirmBusiness"
          />
        </van-action-sheet>

        <div class="cont2" v-if="params.businessValue !== ''">
          <div>
            涉及{{ businessType === 1 ? "产品线(可多选)" : "业务子类(单选)"
            }}<span style="color: red;">*</span>
          </div>
          <div
            :class="item.selected === true ? 'tabblk-active' : 'tabblk'"
            v-for="(item, index) in proLineColumms"
            :key="index"
            @click="SelectProLine(item, index, businessType)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="cont1">
          <van-cell-group class="requried" style="width: calc(100vh - 34px);">
            <van-field
              v-model="params.vehicleValue"
              label="车辆类型"
              placeholder="请选择车辆类型"
              right-icon="arrow-down"
              readonly
              @click="vehicleShow = true"
              style="padding: 16px 0px;"
            />
          </van-cell-group>
        </div>
        <!-- 车辆类型 -->
        <van-action-sheet v-model="vehicleShow">
          <van-picker
            show-toolbar
            :columns="vehicleColumns"
            @cancel="onCancel"
            @confirm="onConfirmVehicle"
          />
        </van-action-sheet>
        <div class="cont1" v-if="params.vehicleValue !== ''">
          <div class="left">预约时间<span style="color: red;">*</span></div>
          <div
            :style="
              params.timeValue == '请选择预约时间'
                ? 'flex: 2.1;color: #969799;'
                : 'flex: 2.1;'
            "
            @click="selectAppointTime"
          >
            <div v-if="isMultipleTime">
              <div
                class="inline"
                :style="Number(params.bookingState) == 2 ? 'color: #666;' : ''"
              >
                <div v-if="params.timeValue == '请选择预约时间'">
                  {{ params.timeValue }}
                </div>
                <div
                  v-else-if="params.multiple_time"
                  :style="{
                    'line-height':
                      params.multiple_time.length > 1 ? '34px' : '54px',
                    'margin-top': params.multiple_time.length > 1 ? '10px' : '0px'
                  }"
                >
                  <div v-for="(item, index) in params.multiple_time" :key="index">
                    {{ params.timeValue }} {{ item.beginTime }}至{{
                      item.endTime
                    }}
                  </div>
                </div>
              </div>
            </div>
            <span
              v-else
              :style="Number(params.bookingState) == 2 ? 'color: #666;' : ''"
            >
              {{
                params.timeValue == "请选择预约时间"
                  ? params.timeValue
                  : `${params.timeValue} ${params.begin_time} 至 ${params.end_time}`
              }}
            </span>
          </div>
          <div class="right"></div>
        </div>
        <van-calendar
          v-model="timeShow"
          color="#009967"
          type="range"
          @confirm="onConfirmTime"
          row-height="58"
          :show-title="false"
          :round="false"
        />

        <div class="cont1" v-if="(params.category == 3 || params.category == 1) && type == 'add'">
          <van-cell-group class="requried" style="width: calc(100vh - 34px);">
            <van-field
              v-model="params.two_factoriesText"
              label="两厂装"
              placeholder="请选择"
              right-icon="arrow-down"
              readonly
              @click="twoFactoriesShow = true"
              style="padding: 16px 0px;"
            />
          </van-cell-group>
        </div>
        <!-- 两厂装 -->
        <van-action-sheet v-model="twoFactoriesShow">
          <van-picker
            show-toolbar
            :columns="twoFactoriesColumns"
            @cancel="onCancel"
            @confirm="onConfirmTwoFactories"
          />
        </van-action-sheet>
      </template>

      <div class="cont3">
        <div class="car-license">
          <div class="car-license-title">请选择车牌</div>
          <div
            :class="isActive1 ? 'car-license-btn-active' : 'car-license-btn'"
            @click="changeBtn(0)"
          >
            普通车牌
          </div>
          <div
            :class="isActive2 ? 'car-license-btn-active' : 'car-license-btn'"
            @click="changeBtn(1)"
          >
            新能源车牌
          </div>
          <div
            :class="isActive3 ? 'car-license-btn-active' : 'car-license-btn'"
            @click="changeBtn(2)"
          >
            港澳车牌
          </div>
          <div class="car-license-title">
            请输入车牌号<span style="color: red;">*</span>
          </div>
          <LicenseKeyBorad
            :type="licenseType"
            ref="licenseKeyBoard"
            @setLicense="setLicense"
            :showRecentUse="true"
            @click.stop="showLicenseKeyBoard"
            @searchRecent="searchRecent"
            @searvchInfoByLicense="searvchInfoByLicense"
            :licenseValue="licenseValue"
          />
        </div>
      </div>

      <div class="cont7">
        <div @click="clearDriverInfo">
          <span class="cont7-btn">清空司机信息</span>
        </div>
        <div @click="openRepoMrg">
          <span class="cont7-btn">快速选择司机</span>
        </div>
      </div>

      <div class="cont4">
        <van-cell-group class="requried">
          <van-field
            v-model="driver.name"
            label="司机姓名"
            placeholder="请输入真实姓名"
          />
          <van-field
            v-model="driver.cardNum"
            label="司机身份证"
            placeholder="请输入身份证"
          />
          <van-field
            v-model="driver.phone"
            label="司机手机号"
            placeholder="请输入手机号"
          />
        </van-cell-group>
      </div>

      <div class="cont5">
        <div style="margin: 4px 0px 14px;">
          司机身份证正反面照片<span style="color: red;">*</span>
          <span
            style="font-size: 14px;float: right;color: #00C8D2;margin-top: 3px;"
            @click.stop="toPhotoGuide"
            >查看拍照指引
            <van-icon name="arrow" style="vertical-align: text-top;" />
          </span>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;">
            <van-uploader
              v-model="file.list1"
              :max-count="1"
              :before-read="onUploadImg"
              :before-delete="(a, b) => beforeDelete(a, b, '0', '0')"
              @click-preview="(a, b) => preview_img(a, b, '0', '0')"
              :after-read="(a, b) => afterRead(a, b, '0', '0')"
            >
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    身份证正面照片
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
          <span style="width: 10px;display: inline-block;"></span>
          <div style="flex: 1;">
            <van-uploader
              v-model="file.list2"
              :max-count="1"
              :before-read="onUploadImg"
              :before-delete="(a, b) => beforeDelete(a, b, '1', '1')"
              @click-preview="(a, b) => preview_img(a, b, '1', '1')"
              :after-read="(a, b) => afterRead(a, b, '1', '1')"
            >
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    身份证反面照片
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
        </div>
      </div>

      <div class="cont5">
        <div style="margin: 4px 0px 14px;">
          驾驶证主页和副页照片<span style="color: red;">*</span>
          <span
            style="font-size: 14px;float: right;color: #00C8D2;margin-top: 3px;"
            @click.stop="toPhotoGuide"
            >查看拍照指引
            <van-icon name="arrow" style="vertical-align: text-top;" />
          </span>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;">
            <van-uploader
              v-model="file.list5"
              :max-count="1"
              :before-read="onUploadImg"
              :before-delete="(a, b) => beforeDelete(a, b, '4', '2')"
              @click-preview="(a, b) => preview_img(a, b, '4', '2')"
              :after-read="(a, b) => afterRead(a, b, '4', '2')"
            >
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    驾驶证主页照片
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
          <span style="width: 10px;display: inline-block;"></span>
          <div style="flex: 1;">
            <van-uploader
              v-model="file.list6"
              :max-count="1"
              :before-read="onUploadImg"
              :before-delete="(a, b) => beforeDelete(a, b, '5', '3')"
              @click-preview="(a, b) => preview_img(a, b, '5', '3')"
              :after-read="(a, b) => afterRead(a, b, '5', '3')"
            >
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    驾驶证副页照片
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
        </div>
      </div>

      <div class="cont5">
        <div style="margin: 4px 0px 14px;">
          行驶证主页和副页照片<span style="color: red;">*</span>
          <span
            style="font-size: 14px;float: right;color: #00C8D2;margin-top: 3px;"
            @click.stop="toPhotoGuide"
            >查看拍照指引
            <van-icon name="arrow" style="vertical-align: text-top;" />
          </span>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;">
            <van-uploader
              v-model="file.list3"
              :max-count="1"
              :before-read="onUploadImg"
              :before-delete="(a, b) => beforeDelete(a, b, '2', '4')"
              @click-preview="(a, b) => preview_img(a, b, '2', '4')"
              :after-read="(a, b) => afterRead(a, b, '2', '4')"
            >
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    行驶证主页照片
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
          <span style="width: 10px;display: inline-block;"></span>
          <div style="flex: 1;">
            <van-uploader
              v-model="file.list4"
              :max-count="1"
              :before-read="onUploadImg"
              :before-delete="(a, b) => beforeDelete(a, b, '3', '5')"
              @click-preview="(a, b) => preview_img(a, b, '3', '5')"
              :after-read="(a, b) => afterRead(a, b, '3', '5')"
            >
              <!-- :preview-options="previewOption" -->
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    行驶证副页照片
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
        </div>
      </div>

      <div class="cont5 fileForm">
        <div style="margin-bottom: 14px;">附件：</div>
        <div style="display: flex;">
          <div style="flex: 1;">
            <van-uploader
              v-model="bookingAttachFileList"
              :max-count="4"
              :before-read="onUploadAttach"
              :before-delete="onDeleteAttach"
            >
              <template #default>
                <div class="card-img-div">
                  <div class="card-img-div-icon">
                    <van-icon name="add-o" size="20px" /><br />
                    上传图片附件
                  </div>
                </div>
              </template>
            </van-uploader>
          </div>
        </div>
    </div>

      <div class="cont6">
        <div style="padding: 0px 16px;">
          备注(选填)
        </div>
        <van-field
          v-model="params.remarks"
          rows="1"
          autosize
          type="textarea"
          placeholder="请输入留言"
        />
      </div>

      <div style="height: 130px;background-color: #f4f5f6;"></div>
      <div class="footer-cont2">
        <van-button
          type="primary"
          block
          class="btnStyle1"
          @click.stop="saveAppoint"
          >保存</van-button
        >
        <van-button block class="btnStyle2" @click.stop="goBack"
          >取消</van-button
        >
      </div>
    </div>

    <div class="timeDiv" v-if="showTime">
      <div class="cont1">
        <div class="left">预约时间<span style="color: red;">*</span></div>
        <div
          :style="
            timePicker.date == '请选择预约时间'
              ? 'flex: 2.1;color: #c8c9cc;'
              : 'flex: 2.1;'
          "
          @click="timeShow = true"
        >
          {{ timePicker.date }}
        </div>
        <div class="right" @click="timeShow = true">
          <van-icon name="notes-o" style="line-height: 50px;" color="#b2b2b2" />
        </div>
      </div>
      <van-calendar
        id="appointEmergeModifyCal"
        v-model="timeShow"
        color="#009967"
        @confirm="onConfirmTime"
        :show-confirm="false"
        :show-title="false"
        row-height="58"
        :round="false"
        position="right"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
      >
        <template slot="footer">
          <div v-if="tDayCanSelct" class="calendar-cont">
            <div style="flex: 1;" @click="setTime">选择今天</div>
          </div>
        </template>
      </van-calendar>

      <div v-if="timePicker.date !== '请选择预约时间'">
        <div class="cont2">
          <div class="cont2-first">时间段</div>
          <div>预约上限</div>
          <div>可预约数</div>
          <div style="flex: 0.1"></div>
        </div>
        <div
          :class="item.color !== '' ? 'cont3 bg456' : 'cont3'"
          v-for="(item, index) in hongtaTime"
          :key="index"
          @click="changeAppointTime(item)"
        >
          <div class="cont3-first">
            <span>{{ `${item.begin_time} 至 ${item.end_time}` }}</span>
          </div>
          <div class="cont3-second">
            <div v-if="item.isLimit">
              {{ item.total_number === -1 ? "不限" : item.total_number }}
            </div>
            <div v-else>
              {{ item.total_number === 0 ? "不限" : item.total_number }}
            </div>
          </div>
          <div
            class="cont3-third"
            :style="item.color !== '' ? 'color: #666666' : ''"
          >
            <span>剩余：</span>
            <span v-if="item.isLimit">
              {{
                item.total_number === -1
                  ? "不限"
                  : item.used_number > item.total_number
                  ? 0
                  : item.total_number - item.used_number
              }}
            </span>
            <span v-else>
              {{
                item.total_number == 0
                  ? "不限"
                  : item.used_number > item.total_number
                  ? 0
                  : item.total_number - item.used_number
              }}
            </span>
          </div>
          <div class="cont3-forth">
            <van-icon name="success" color="#008B5E" v-if="item.tag" />
          </div>
        </div>
        <Empty v-if="hongtaTime.length == 0"></Empty>
        <div style="height: 86px;background-color: #fff;"></div>
      </div>
      <div
        class="footer-cont"
        @click="timePicker.date === '请选择预约时间' ? '' : saveTime()"
      >
        <van-button
          type="primary"
          block
          :class="
            timePicker.date === '请选择预约时间' ? 'btnStyle3' : 'btnStyle1'
          "
          >确定</van-button
        >
      </div>
    </div>
    <wxDriverContact
      v-if="showWxDriverContact"
      getDataUrl="/api/queue/emergency/search_driver"
      getDetailUrl="/api/queue/emergency/search_id_card_info"
      @wxExcomfireSelect="wxExcomfireSelect"
      @wxExcomfireComBack="wxExcomfireComBack"
    ></wxDriverContact>
  </div>
</template>
<script>
import moment from "moment";
import LicenseKeyBorad from "../../../components/license";
import { ImagePreview } from "vant";
import Empty from "@/components/tips/Empty.vue";
import wxDriverContact from "@/components/wxDriverContact";
import { VEHICLE_TYPE_LIST, getVehicleTypeLabel, getVehicleTypeId } from "@/assets/js/vehicleTypeEnum";
// 生成随机字符串
const { nanoid } = require("nanoid")
export default {
  components: {
    LicenseKeyBorad,
    Empty,
    wxDriverContact
  },
  data() {
    return {
      dischargeBusinessShow: false,
      categoryShow: false,
      twoFactoriesShow: false,
      areaShow: false,
      businessShow: false,
      vehicleShow: false,
      dischargeVehicleShow: false,      
      areaColumns: [], // 厂区
      businessColumns: [], // 业务
      dischargeBusinessColumns: [], // 业务
      categoryColumns: [
        {text: '装车', id: 1}, 
        {text: '卸货', id: 2}, 
        // {text: '装车及卸货', id: 3}
      ], // 业务大类
      proLineColumms: [], // 产品线
      dischargeProLineColumms: [],
      // vehicleColumns: ["平板车", "货柜车", "槽罐车", "其他", "高栏车"],
      vehicleColumns: [
        {
          text: "请先选择厂区和业务",
          disabled: true
        }
      ],
      dischargeVehicleColumns: [
        {
          text: "请先选择厂区和业务",
          disabled: true
        }
      ],
      twoFactoriesColumns: [
        {
          text: "是",
          id: "1"
        },
        {
          text: "否",
          id: "0"
        }
      ],
      businessType: "", // 当前选择的业务类型
      dischargeBusinessValue: "",
      dischargeBusinessType: "", // 当前选择的业务类型
      dischargeVehicleValue: "",
      // vehicleValue: "",
      isActive1: true,
      isActive2: false,
      isActive3: false,
      licenseType: "normal",
      licenseValue: "", //车牌值
      driver: {
        name: "",
        cardNum: "",
        phone: ""
      },
      fileListObj: [],
      file: {
        list1: [],
        list2: [],
        list3: [],
        list4: [],
        list5: [],
        list6: [],
        index: ""
      },
      rowDataObj: {},
      formShow: true, // 表单Div显示
      showTime: false, // 预约时间Div显示
      timePicker: {
        date: "请选择预约时间",
        beginTime: "",
        endTime: "",
        instanceId: ""
      },
      // timeValue: "请选择预约时间",
      timeShow: false,
      hongtaTime: [],
      appointTimeSource: {},
      bookingAttachFileList: [],
      params: {
        booking_attach: [], // 附件
        category: 1,
        categoryValue: "装车",
        dischargeInstanceId: "",
        discharge_begin_time: "",
        discharge_end_time: "",
        dischargeTimeValue: "请选择预约时间",
        dischargeBusinessId: "", // 业务id
        dischargeProLineSelect: [],
        dischargeBusinessValue: "", // 业务
        dischargeVehicleValue: "",
        dischargeType: "",
        // 两厂装
        two_factories: "0",
        two_factoriesText: "否",
        discharge_multiple_time: [],
        bookingState: "", // 预约状态
        instanceId: "", // 预约时间实例id
        begin_time: "",
        end_time: "",
        timeValue: "请选择预约时间", // 日期
        comId: "", // 厂区id
        businessId: "", // 业务id
        proLineSelect: [], // 产品线选择
        remarks: "",
        areaValue: "", // 厂区
        unitName: "", // 运输单位
        businessValue: "", // 业务
        vehicleValue: "", // 车型
        type: "", //业务类型
        discharge_order_code: "", // 单据编号（卸货业务）
        order_code: "", // 单据编号（装货及卸货业务）
        delivery_unit: "", // 收货单位（装货及卸货业务）
        discharge_delivery_unit: "", // 收货单位（卸货业务）
      },
      minDate: new Date(),
      maxDate: new Date(moment().year() + 10, 0, 1),
      previewOption: {
        images: [], // 图片数组
        showIndex: true,
        loop: true,
        startPosition: 0
      },
      imageObj: {},
      appointEmergeModifyInterval: null, // 2秒钟缓存数据
      bookingDays: [], //预约时间
      showWxDriverContact: false,
      multiple_time: [],
      discharge_multiple_time: [],
      isDischarge: false, // 判断是否是第二个业务
    };
  },
  async mounted() {
    await this.getList();
    // 先设置缓存 -> 如有id，查详情时则会自动覆盖
    setTimeout(() => {
      setTimeout(() => {
        if (this.type !== "edit") {
          if (
            JSON.parse(localStorage.getItem("appointEmergeModify")) !== null
          ) {
            let obj = JSON.parse(localStorage.getItem("appointEmergeModify"));
                        // 缓存附件会导致附件无法被删除
                        if (obj.params.booking_attach) {
              obj.params.booking_attach = []
            }
            this.params = obj.params;
            this.timePicker = obj.timePicker;
            this.isActive1 = obj.isActive1;
            this.isActive2 = obj.isActive2;
            this.isActive3 = obj.isActive3;
            this.licenseType = obj.licenseType;
            this.licenseValue = obj.licenseValue;
            this.driver = obj.driver;
            this.file = obj.file;
            this.fileListObj = obj.fileListObj;
            this.businessType = obj.businessType;
            this.dischargeBusinessType = obj.dischargeBusinessType;
            this.previewOption = obj.previewOption;

            // 厂区
            for (let i = 0; i < this.rowDataObj.length; i++) {
              if (this.params.comId === this.rowDataObj[i].id) {
                  let obj = [];
                let d_arr = [];
                this.rowDataObj[i].business.forEach(items => {
                  obj.push({
                    ...items,
                    text: items.name,
                  });
                  if (items.category == 2) {
                    d_arr.push({
                      ...items,
                      text: items.name
                    });
                  }
                });
                this.businessColumns = obj;
                this.dischargeBusinessColumns = d_arr;
              }
            }
            // 业务
            this.proLineColumms = [];
            for (let i = 0; i < this.businessColumns.length; i++) {
              if (this.businessColumns[i].id === this.params.businessId) {
                this.businessColumns[i].sub_buness.forEach(item => {
                  this.proLineColumms.push({
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    selective_type: this.businessType,
                    selected: false
                  });
                });
                // 车型
                this.setVehicleTypeColumns(
                  this.businessColumns[i].vehicle_type
                );
              }
            }
            // 业务子类/产品线
            for (let i = 0; i < this.proLineColumms.length; i++) {
              for (let j = 0; j < obj.params.proLineSelect.length; j++) {
                if (
                  this.proLineColumms[i].id === obj.params.proLineSelect[j].id
                ) {
                  this.proLineColumms[i].selected = true;
                }
              }
            }
            // 业务2
            this.dischargeProLineColumms = [];
            for (let i = 0; i < this.dischargeBusinessColumns.length; i++) {
              if (this.dischargeBusinessColumns[i].id === this.params.dischargeBusinessId) {
                this.dischargeBusinessColumns[i].sub_buness.forEach(item => {
                  this.dischargeProLineColumms.push({
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    selective_type: this.dischargeBusinessType,
                    selected: false
                  });
                });
                // 车型
                this.setDischargeVehicleTypeColumns(
                  this.dischargeBusinessColumns[i].vehicle_type
                );
              }
            }
            // 业务子类/产品线
            for (let i = 0; i < this.dischargeProLineColumms.length; i++) {
              for (
                let j = 0;
                j < obj.params.dischargeProLineSelect.length;
                j++
              ) {
                if (
                  this.dischargeProLineColumms[i].id === obj.params.dischargeProLineSelect[j].id
                ) {
                  this.dischargeProLineColumms[i].selected = true;
                }
              }
            }
          }
        }
        this.getDetail();
      }, 1000);
      // 2秒钟定时刷新，缓存数据
      if (this.type !== "edit") {
        this.appointEmergeModifyInterval = window.setInterval(() => {
          this.beforeunloadFn();
        }, 2000);
      }
    }, 1000);
  },
  beforeRouteUpdate(a, b, n) {
    console.log(a, b);
    this.showTime = !this.showTime;
    this.formShow = !this.formShow;
    if (String(this.showTime) === "true") {
      document.title = "选择预约时间";
    } else {
      if (this.type === "add") {
        document.title = "添加预约信息";
      } else {
        document.title = "编辑预约信息";
      }
    }
    // }
    n();
  },
  methods: {
    // 确认选择司机信息
    wxExcomfireSelect(data) {
      console.log(data);
      this.showWxDriverContact = false;
      this.showTime = false;
      this.formShow = true;
      // 重置司机相关图片信息
      this.file.list1 = [];
      this.file.list2 = [];
      this.file.list5 = [];
      this.file.list6 = [];
      this.previewOption.images = [];
      // 填充司机信息
      this.driver.name = data.info.name;
      this.driver.cardNum = data.info.id_card;
      this.driver.phone = data.info.contact;
      // 存储驾驶证照片信息
      let copyFileList = [];
      this.fileListObj.forEach(item => {
        if (Number(item.type) === 2) {
          copyFileList.push(item);
        } else if (Number(item.type) === 3) {
          copyFileList.push(item);
        }
      });
      console.log(copyFileList);
      this.fileListObj = [];
      // 重置前四张图片
      data.file.forEach(item => {
        let newObj = {
          url: item.real_path,
          urlObj: item,
          type: item.type
        };
        if (Number(item.type) === 0) {
          item.index = 0;
          this.file.list1.push(newObj);
          this.fileListObj.splice(item.index, 0, item);
        } else if (Number(item.type) === 1) {
          item.index = 1;
          this.file.list2.push(newObj);
          this.fileListObj.splice(item.index, 0, item);
        } else if (Number(item.type) === 4) {
          item.index = 2;
          this.file.list5.push(newObj);
          this.fileListObj.splice(item.index, 0, item);
        } else if (Number(item.type) === 5) {
          item.index = 3;
          this.file.list6.push(newObj);
          this.fileListObj.splice(item.index, 0, item);
        }
      });
      // push驾驶证图片
      copyFileList.forEach(item => {
        this.fileListObj.push(item);
      });
      // 更新预览的图片信息
      this.fileListObj.forEach(item => {
        this.previewOption.images.push(item.real_path);
      });
    },

    // 取消选择司机信息
    wxExcomfireComBack() {
      this.showWxDriverContact = false;
      this.showTime = false;
      this.formShow = true;
    },

    // 缓存页面信息
    beforeunloadFn() {
      let obj = {
        params: this.params,
        timePicker: this.timePicker,
        isActive1: this.isActive1,
        isActive2: this.isActive2,
        isActive3: this.isActive3,
        licenseType: this.licenseType,
        licenseValue: this.licenseValue,
        driver: this.driver,
        file: this.file,
        fileListObj: this.fileListObj,
        businessType: this.businessType,
        dischargeBusinessType: this.dischargeBusinessType,
        previewOption: this.previewOption
      };
      localStorage.setItem("appointEmergeModify", JSON.stringify(obj));
    },

    openRepoMrg() {
      // 查询初始化
      this.showWxDriverContact = true;
      this.showTime = false;
      this.formShow = false;
    },

    // 设置业务关联的车型
    setVehicleTypeColumns(arr) {
      if (arr.length === 0) {
        this.vehicleColumns = VEHICLE_TYPE_LIST.map(v => ({ text: v.name, id: v.id }));
      } else {
        this.vehicleColumns = arr
          .map(id => VEHICLE_TYPE_LIST.find(v => v.id === Number(id)))
          .filter(Boolean)
          .map(v => ({ text: v.name, id: v.id }));
      }
    },

    setDischargeVehicleTypeColumns(arr) {
      if (arr.length === 0) {
        this.dischargeVehicleColumns = VEHICLE_TYPE_LIST.map(v => ({ text: v.name, id: v.id }));
      } else {
        this.dischargeVehicleColumns = arr
          .map(id => VEHICLE_TYPE_LIST.find(v => v.id === Number(id)))
          .filter(Boolean)
          .map(v => ({ text: v.name, id: v.id }));
      }
    },

    // 附件删除
    onDeleteAttach(e) {
      const { index } = e;
      this.params.booking_attach.splice(index, 1);
      return true;
    },

    // 附件上传
    async onUploadAttach(file, detail) {
      console.log(file, detail);
      let data = new FormData();
      data.append("file", file);
      data.append("rotate", 1);
      await new Promise(resolve => {
        if (!/(\.jpeg)|(\.jpg)|(\.png)/.test(file.name.toLowerCase())) {
          this.$common.mbToastFail("只能上传jpeg、jpg、png文件");
          return false;
        }
        if (file.size > 1024 * 1000 * 20) {
          this.$common.mbToastFail("文件大小不能超过20M");
          return false;
        }
        this.$common
          .http({
            url: "/api/media/upload",
            file: data
          })
          .then(res => {
            let item = res.data.data;
            this.params.booking_attach = !this.params.booking_attach ? [] : this.params.booking_attach
            this.params.booking_attach.push({
              "real_path": item.real_path,
              "hash": item.hash,
              "path": item.path,
              "ext": item.ext,
              "filesize": item.filesize,
              "origin_size": item.origin_size
            });
            resolve(res.data.data);
          });
      });
    },

    // 上传文件
    async onUploadImg(file, detail) {
      console.log(detail, file);
      let data = new FormData();
      data.append("file", file);
      data.append("rotate", 1); // 旋转
      await new Promise(resolve => {
        if (!/(\.jpeg)|(\.jpg)|(\.png)/.test(file.name.toLowerCase())) {
          this.$common.mbToastFail("只能上传jpeg、jpg、png文件");
          return false;
        }
        if (file.size > 1024 * 1000 * 20) {
          this.$common.mbToastFail("文件大小不能超过20M");
          return false;
        }
        this.$common
          .http({
            url: "/api/media/upload",
            file: data
          })
          .then(res => {
            console.log(res);
            let obj = res.data.data;
            this.imageObj = obj;
            obj.id = 0;
            // this.fileListObj.push(obj);
            // this.previewOption.images.push(res.data.data.real_path);
            resolve(res.data.data);
          });
      });
    },

    // 删除照片
    beforeDelete(file, detail, tag, index) {
      console.log(file, detail, tag, index);
      this.fileListObj.forEach((item, i) => {
        // if (item.type === Number(tag)) {
        //   this.fileListObj.splice(i, 1);
        //   this.previewOption.images.splice(i, 1);
        // }
        if (Number(item.index) === Number(index)) {
          console.log(item.index);
          this.fileListObj.splice(i, 1);
          this.previewOption.images.splice(i, 1);
        }
      });
      // this.fileListObj.splice(Number(file.type), 1);
      // this.previewOption.images.splice(Number(file.type), 1);
      return true;
    },

    // 读取完成后
    afterRead(file, detail, tag, index) {
      console.log(file);
      file.type = Number(tag);
      this.imageObj.type = Number(tag);
      this.imageObj.index = Number(index);
      // this.fileListObj.splice(Number(tag), 0, this.imageObj);
      // this.previewOption.images.splice(Number(tag), 0, this.imageObj.real_path);
      this.fileListObj.splice(Number(index), 0, this.imageObj);
      this.previewOption.images.splice(
        Number(index),
        0,
        this.imageObj.real_path
      );
    },

    // 点击预览时触发
    preview_img(file, detail, tag, index) {
      console.log(file, detail, tag);
      // this.previewOption.startPosition = Number(file.type);
      let newIndex = "";
      this.fileListObj.forEach((item, i) => {
        // if (item.type === Number(tag)) {
        //   newIndex = i;
        // }
        if (item.index === Number(index)) {
          newIndex = i;
        }
      });
      ImagePreview({
        images: this.previewOption.images, // 图片数组
        showIndex: true,
        loop: true,
        startPosition: newIndex
      });
    },

    // 取消picker
    onCancel() {
      this.areaShow = false;
      this.businessShow = false;
      this.dischargeBusinessShow = false;
      this.vehicleShow = false;
      this.dischargeVehicleShow = false;
      this.twoFactoriesShow = false;
      this.categoryShow = false;
    },

    // 确认选择业务大类
    onConfirmCategory(val) {
      this.params.categoryValue = val.text;
      this.params.category = val.id;
      this.onConfirmArea({
        text: this.params.areaValue,
        id: this.params.comId
      });
      this.onCancel();
    },

    // 确认选择厂区
    onConfirmArea(val) {
      console.log(val);
      // this.areaValue = val.text;
      this.params.areaValue = val.text;
      this.areaShow = false;
      this.params.comId = val.id;
      // 切换厂区，重置业务线
      this.businessColumns = []; // 业务线清空
      this.dischargeBusinessColumns = []; // 业务线清空
      // this.businessValue = "请选择业务"; // 业务值清空
      this.params.businessValue = ""; // 业务值清空
      this.params.dischargeBusinessValue = ""; // 业务值清空
      this.params.proLineSelect = []; // 产品线选择清空
      this.params.dischargeProLineSelect = [];
      this.params.timeValue = "请选择预约时间"; // 预约时间清空
      this.params.dischargeTimeValue = "请选择预约时间"; // 预约时间清空
      this.params.begin_time = ""; // 预约开始时间清空
      this.params.end_time = ""; // 预约结束时间清空
      this.params.vehicleValue = ""; //车辆类型清空
      this.params.dischargeVehicleValue = ""; //车辆类型清空
      this.params.two_factories = "0"; //两厂装设置为否
      this.params.type = ""; //业务类型清空
      this.params.order_code = ""; //单据编号清空
      this.params.discharge_order_code = ""; //单据编号清空
      this.params.delivery_unit = ""; // 收货单位清空
      this.params.discharge_delivery_unit = ""; // 收货单位清空
      this.rowDataObj.forEach(item => {
        if (item.id === val.id) {
          if (item.business) {
            item.business.forEach(items => {
              this.businessColumns.push({
                ...items,
                text: items.name
              });
              if (items.category == 2) {
                this.dischargeBusinessColumns.push({
                  ...items,
                  text: items.name
                });
              }
            });
            console.log(item.business);
          } else {
            this.businessColumns.push({
              text: "暂无数据",
              disabled: true
            });
            this.dischargeBusinessColumns.push({
              text: "暂无数据",
              disabled: true
            });
          }
        }
      });
      // 重置产品线选中状态
      this.proLineColumms.forEach(item => {
        item.selected = false;
      });
    },

    // 确认选择业务
    onConfirmBusiness(val) {
      console.log(val);
      // this.businessValue = val.text;
      if (val.text === "暂无数据") {
        this.businessShow = false;
        return false;
      }
      this.params.businessValue = val.text;
      this.params.type = val.type;
      this.businessType = val.selective_type;
      this.params.businessId = val.id;
      this.businessShow = false;
      // 重置产品线选中
      this.proLineColumms = []; // 产品线列表
      this.params.proLineSelect = []; // 产品线选择清空
      this.params.timeValue = "请选择预约时间"; // 预约时间清空
      this.params.begin_time = ""; // 预约时间清空
      this.params.end_time = ""; // 预约时间清空
      this.params.vehicleValue = ""; //车辆类型清空
      this.params.two_factories = "0";
      this.params.type = ""; // 业务类型清空
      val.sub_buness.forEach(item => {
        console.log(item);
        this.proLineColumms.push({
          id: item.id,
          name: item.name,
          type: item.type,
          selective_type: val.selective_type,
          selected: false
        });
      });
      this.setVehicleTypeColumns(val.vehicle_type);
    },

    onConfirmDischargeBusiness(val) {
      if (val.text === "暂无数据") {
        this.dischargeBusinessShow = false;
        return false;
      }
      this.params.dischargeBusinessValue = val.text;
      this.params.dischargeBusinessId = val.id;
      this.dischargeType = val.type;
      this.dischargeBusinessType = val.selective_type;
      this.dischargeBusinessShow = false;
      this.dischargeProLineColumms = []
      this.dischargeProLineSelect = []
      this.params.dischargeTimeValue = "请选择预约时间"; // 预约时间清空
      this.dischargeVehicleValue = "";
      val.sub_buness.forEach(item => {
        console.log(item);
        this.dischargeProLineColumms.push({
          id: item.id,
          name: item.name,
          type: item.type,
          selective_type: val.selective_type,
          selected: false
        });
      });
      this.setDischargeVehicleTypeColumns(val.vehicle_type)
    },

    // 确认选择车辆类型
    onConfirmVehicle(val) {
      console.log(val);
      // this.vehicleValue = val;
      this.vehicleShow = false;
      if (val.text === "请先选择厂区和业务") {
        return false;
      }
      this.params.vehicleValue = val.text;
      this.vehicleShow = false;
    },

    onConfirmDischargeVehicle(val) {
      this.dischargeVehicleShow = false;
      if (val.text === "请先选择厂区和业务") {
        return false;
      }
      this.params.dischargeVehicleValue = val.text;
    },

    // 确认选择两厂装
    onConfirmTwoFactories(val) {
      this.twoFactoriesShow = false
      this.params.two_factories = val.id;
      this.params.two_factoriesText = val.text;
    },

    // 选择产品线
    SelectProLine(item, index, tag) {
      this.params.proLineSelect = [];
      if (Number(tag) === 1) {
        // 多选
        this.proLineColumms[index].selected = !item.selected;
        for (let i = 0; i < this.proLineColumms.length; i++) {
          if (this.proLineColumms[i].selected) {
            this.params.proLineSelect.push(this.proLineColumms[i]);
          }
        }
      } else {
        // 单选
        for (let i = 0; i < this.proLineColumms.length; i++) {
          this.proLineColumms[i].selected = false;
        }
        this.proLineColumms[index].selected = !item.selected;
        if (this.proLineColumms[index].selected) {
          this.params.proLineSelect.push(this.proLineColumms[index]);
        }
      }
    },

    SelectDischargeProLine(item, index, tag) {
      this.params.dischargeProLineSelect = [];
      if (Number(tag) === 1) {
        // 多选
        this.dischargeProLineColumms[index].selected = !item.selected;
        for (let i = 0; i < this.dischargeProLineColumms.length; i++) {
          if (this.dischargeProLineColumms[i].selected) {
            this.params.dischargeProLineSelect.push(this.dischargeProLineColumms[i]);
          }
        }
      } else {
        // 单选
        for (let i = 0; i < this.dischargeProLineColumms.length; i++) {
          this.dischargeProLineColumms[i].selected = false;
        }
        this.dischargeProLineColumms[index].selected = !item.selected;
        if (this.dischargeProLineColumms[index].selected) {
          this.params.dischargeProLineSelect.push(this.dischargeProLineColumms[index]);
        }
      }
    },

    // 切换车牌类型
    changeBtn(val) {
      this.isActive1 = val == 0 ? true : false;
      this.isActive2 = val == 1 ? true : false;
      this.isActive3 = val == 2 ? true : false;
      if (this.isActive1) {
        this.licenseType = "normal";
      }
      if (this.isActive2) {
        this.licenseType = "newEnergy";
      }
      if (this.isActive3) {
        this.licenseType = "HKorMacao";
      }
      this.$refs.licenseKeyBoard.emptyArray(); //清空内容
    },

    // 获取键盘数据
    setLicense(first, numArr) {
      this.licenseValue = first + numArr.join("");
    },

    // 隐藏键盘
    hideLicenseKeyBoard() {
      if (String(this.$refs.licenseKeyBoard) !== "undefined") {
        this.$refs.licenseKeyBoard.close_keyboard();
      }
    },

    // 弹起键盘
    showLicenseKeyBoard() {
      this.$refs.LicenseKeyBorad.clickShowKeyboard();
    },

    // 查询车牌缓存
    searchRecent(first, numArr) {
      this.$common
        .http({
          url: "/api/queue/emergency/search_license_plate",
          data: {
            license_plate: first + numArr.join("")
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.$refs.licenseKeyBoard.setRecentUse(res.data.data);
        });
    },

    // 设置具体车牌的关联的下文信息
    searvchInfoByLicense(first, numArr) {
      this.$common
        .http({
          url: "/api/queue/emergency/search_license_plate_info",
          data: {
            license_plate: first + numArr.join("")
          }
        })
        .then(res => {
          console.log(res.data.data);
          let obj = res.data.data;
          if (obj.length === 0) {
            return false;
          }
          // 附件信息与司机信息不关联，前端过滤
          obj.booking_attach = [];
          this.setValue(obj);
          setTimeout(() => {
            this.$common.mbToastSuccess("已为您自动填充该车牌的关联信息");
          }, 1200);
        });
    },

    // 保存预约信息
    async saveAppoint() {
      // let codeNumberReg = /^[A-Za-z0-9]+$/;
      if (this.params.areaValue.trim() === "") {
        this.$common.mbToastFail("请选择厂区");
        return false;
      }
      if (this.params.unitName.trim() === "") {
        this.$common.mbToastFail("请输入运输单位");
        return false;
      }
      if (this.params.unitName.trim().length > 20) {
        this.$common.mbToastFail("运输单位不能超过20个字符");
        return false;
      }
      if (this.params.order_code.trim() === "") {
        this.$common.mbToastFail("请输入单据编号");
        return false;
      }
      // if (!codeNumberReg.test(this.params.order_code.trim())) {
      //   this.$common.mbToastFail("请输入数字和字母的组合");
      //   return false;
      // }
      if (this.params.delivery_unit.trim() === "") {
        this.$common.mbToastFail("请输入收货单位");
        return false;
      }
      if (this.params.businessValue.trim() === "") {
        this.$common.mbToastFail("请选择业务");
        return false;
      }
      if (this.businessType === 1 && this.params.proLineSelect.length === 0) {
        this.$common.mbToastFail("请至少选择一个产品线");
        return false;
      }
      if (this.businessType === 0 && this.params.proLineSelect.length === 0) {
        this.$common.mbToastFail("请选择业务子类");
        return false;
      }
      if (this.params.timeValue.trim() === "请选择预约时间") {
        this.$common.mbToastFail("请选择预约时间");
        return false;
      }
      // 如果选择了装车及卸货时才校验 dischargeBusinessId
      if (this.params.category == 3) {
        if (this.params.dischargeBusinessValue.trim() === "") {
          this.$common.mbToastFail("请选择业务");
          return false;
        }
        if (this.params.discharge_order_code.trim() === "") {
          this.$common.mbToastFail("请输入单据编号");
          return false;
        }
        // if (codeNumberReg.test(this.params.discharge_order_code.trim())) {
        //   this.$common.mbToastFail("单据编号只能由数字字母组成");
        //   return false;
        // }
        if (this.params.discharge_delivery_unit.trim() === "") {
          this.$common.mbToastFail("请输入收货单位");
          return false;
        }
        if (
          this.dischargeBusinessType === 1 &&
          this.params.dischargeProLineSelect.length === 0
        ) {
          this.$common.mbToastFail("请至少选择一个产品线");
          return false;
        }
        if (
          this.dischargeBusinessType === 0 &&
          this.params.dischargeProLineSelect.length === 0
        ) {
          this.$common.mbToastFail("请选择业务子类");
          return false;
        }
        if (this.params.dischargeTimeValue.trim() === "请选择预约时间") {
          this.$common.mbToastFail("请选择预约时间");
          return false;
        }
        // if (this.params.timeValue.trim() != this.params.dischargeTimeValue.trim()) {
        //   this.$common.mbToastFail("装车及卸货关联业务预约需要同一天！");
        //   return false;
        // }
        const beginTimeDischarge = new Date(`${this.params.dischargeTimeValue} ${this.params.discharge_begin_time}`).getTime();
        const beginTimeNumberDefault = new Date(`${this.params.timeValue} ${this.params.begin_time}`).getTime();
        if (beginTimeDischarge > beginTimeNumberDefault) {
          this.$common.mbToastFail("卸货预约开始时间需小于装车预约开始时间，请重新选择预约时间。");
          return false;
        }
      }
      if (
        this.licenseValue.trim() === "" ||
        (this.licenseType === "normal" && this.licenseValue.length < 7) ||
        (this.licenseType === "newEnergy" && this.licenseValue.length < 8) ||
        (this.licenseType === "HKorMacao" && this.licenseValue.length < 7)
      ) {
        this.$common.mbToastFail("请完善车牌号");
        return false;
      }
      if (this.params.vehicleValue.trim() === "") {
        this.$common.mbToastFail("请选择车辆类型");
        return false;
      }
      if (this.driver.name.trim() === "") {
        this.$common.mbToastFail("司机姓名不能为空");
        return false;
      }
      if (this.driver.cardNum.trim() === "") {
        this.$common.mbToastFail("司机身份证不能为空");
        return false;
      }
      if (
        !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.driver.cardNum.trim()
        )
      ) {
        this.$common.mbToastFail(`司机身份证号码格式不正确！`);
        return;
      }
      if (this.driver.phone.trim() === "") {
        this.$common.mbToastFail("司机手机号不能为空");
        return false;
      }
      if (!/^1[0-9]{10}$/.test(this.driver.phone.trim())) {
        this.$common.mbToastFail(`司机手机号格式不正确`);
        return false;
      }
      if (this.file.list1.length === 0) {
        this.$common.mbToastFail(`请上传身份证正面照片`);
        return false;
      }
      if (this.file.list2.length === 0) {
        this.$common.mbToastFail(`请上传身份证反面照片`);
        return false;
      }
      if (this.file.list3.length === 0) {
        this.$common.mbToastFail(`请上传行驶证主页照片`);
        return false;
      }
      if (this.file.list4.length === 0) {
        this.$common.mbToastFail(`请上传行驶证副页照片`);
        return false;
      }
      if (this.file.list5.length === 0) {
        this.$common.mbToastFail(`请上传驾驶证主页照片`);
        return false;
      }
      if (this.file.list6.length === 0) {
        this.$common.mbToastFail(`请上传驾驶证副页照片`);
        return false;
      }
      if (this.params.two_factories == 1) {
        let res = await this.$common.http({
          url: "/api/queue/dispatcher/check_factories_business",
          data: {
            business_id: this.params.businessId
          }
        });
        if (res.data.errcode == 0) {
          if (res.data.data.business_in_two_factories == 0) {
            this.$common.mbToastFail(`当前业务不支持两厂装`);
            return false;
          }
        } else {
          this.$common.mbToastFail(`当前业务不支持两厂装`);
          return false;
        }
      }
      let business_ids = [];
      this.params.proLineSelect.forEach(item => {
        business_ids.push(item.id);
      });
      let d_business_ids = [];
      this.params.dischargeProLineSelect.forEach(item => {
        d_business_ids.push(item.id);
      });
      let vehicleId = getVehicleTypeId(this.params.vehicleValue) || "";

      let d_vehicleId = getVehicleTypeId(this.params.dischargeVehicleValue) || "";

      let license_plate_type = "";
      if (this.licenseType == "normal") {
        license_plate_type = 0;
      }
      if (this.licenseType == "newEnergy") {
        license_plate_type = 1;
      }
      if (this.licenseType == "HKorMacao") {
        license_plate_type = 2;
      }
      let booking_info = {
        // license_plate_type: this.licenseType === "normal" ? 0 : 1,
        license_plate_type,
        license_plate: this.licenseValue,
        name: this.driver.name,
        id_card: this.driver.cardNum.toUpperCase(),
        contact: this.driver.phone,
        vehicle_type: vehicleId
        // vehicle_type: this.vehicleColumns.indexOf(this.params.vehicleValue) + 1
      };

      let d_booking_info = {
        license_plate_type,
        license_plate: this.licenseValue,
        name: this.driver.name,
        id_card: this.driver.cardNum.toUpperCase(),
        contact: this.driver.phone,
        vehicle_type: d_vehicleId
      };
      console.log(this.vehicleColumns, booking_info);
      if (this.isMultipleTime && this.params.multiple_time.length > 0) {
        this.params.multiple_time.map((item, index) => {
          let data = {
            com_id: this.params.comId,
            business_ids: JSON.stringify(business_ids),
            booking_time_instance_number_id: item.instanceId,
            booking_info: JSON.stringify(booking_info),
            booking_info_file: JSON.stringify(this.fileListObj),
            note: this.params.remarks,
            unit_name: this.params.unitName,
            type: this.params.type,
            two_factories: this.params.two_factories,
            source_key: nanoid(32),
            order_code: this.params.order_code,
            delivery_unit: this.params.delivery_unit,
            booking_attach: JSON.stringify(this.params.booking_attach)
          };
          let jump = false;

          if (index == this.params.multiple_time.length - 1) {
            jump = true;
          } else {
            jump = false;
          }
          //  debugger;
          this.saveAppointInfo(data, jump);
        });
      } else {
        let source_key = nanoid(32);
        let data = {
          com_id: this.params.comId,
          business_ids: JSON.stringify(business_ids),
          booking_time_instance_number_id: this.params.instanceId,
          booking_info: JSON.stringify(booking_info),
          booking_info_file: JSON.stringify(this.fileListObj),
          note: this.params.remarks,
          unit_name: this.params.unitName,
          type: this.params.type,
          two_factories: this.params.two_factories,
          source_key,
          order_code: this.params.order_code,
          delivery_unit: this.params.delivery_unit,
          booking_attach: JSON.stringify(this.params.booking_attach)
        };
        let discharge_data = {
          com_id: this.params.comId,
          business_ids: JSON.stringify(d_business_ids),
          booking_time_instance_number_id: this.params.dischargeInstanceId,
          booking_info_file: JSON.stringify(this.fileListObj),
          booking_info: JSON.stringify(d_booking_info),
          note: this.params.remarks,
          type: this.params.type,
          source_key,
          order_code: this.params.discharge_order_code,
          delivery_unit: this.params.discharge_delivery_unit,
          booking_attach: JSON.stringify(this.params.booking_attach)
        }
        let jump_state = this.params.category == 3
        this.saveAppointInfo(data, !jump_state).then((res_state) => {
          if (res_state) {
            if (jump_state) {
              this.saveAppointInfo(discharge_data, jump_state);
            }
          }
        });
      }
    },
    saveAppointInfo(data, jump) {
      return new Promise((resolve) => {
        console.log(jump);
        let url = "";
        if (this.type === "edit") {
          url = "/api/queue/emergency/edit_booking";
          data.id = this.id;
        } else {
          url = "/api/queue/emergency/booking_business";
        }
        console.log(data);
        this.$common
          .http({
            url: url,
            data: data
          })
          .then(() => {
            window.clearInterval(this.appointEmergeModifyInterval);
            this.appointEmergeModifyInterval = null;
            localStorage.removeItem("appointEmergeModify");
            this.$common.mbToastSuccess("保存成功");
            this.$common
              .http({
                url: "/api/queue/emergency/query_draft_booking"
              })
              .then(res => {
                if (res.data.data.length > 0) {
                  if (jump) {
                    this.$router.push({
                      path: "/rhwxEmergeAppointAdd",
                      query: {
                        time1: this.time1,
                        time2: this.time2,
                        keyword: this.keyword
                      }
                    });
                  }
                } else {
                  if (this.pageType === "list") {
                    this.$router.push({
                      path: "/rhwxEmergeAppointList",
                      query: {
                        time1: this.time1,
                        time2: this.time2,
                        keyword: this.keyword
                      }
                    });
                  } else if (this.pageType === "detail") {
                    this.$router.push({
                      path: "/rhwxEmergeAppointDetail",
                      query: {
                        id: this.id,
                        info_id: this.info_id,
                        time1: this.time1,
                        time2: this.time2,
                        keyword: this.keyword
                      }
                    });
                  } else if (this.pageType === "add") {
                    this.$router.push({
                      path: "/rhwxEmergeAppointAdd",
                      query: {
                        time1: this.time1,
                        time2: this.time2,
                        keyword: this.keyword
                      }
                    });
                  }
                }
              });
              resolve(true);
          }).catch(() => {
            resolve(false);
          });
      })
    },

    // 获取厂区，业务等列表
    async getList() {
      await this.$common
        .http({
          url: "/api/queue/emergency/get_booking_data",
          data: {}
        })
        .then(res => {
          this.rowDataObj = res.data.data;
          this.rowDataObj.forEach(item => {
            this.areaColumns.push({
              text: item.name,
              id: item.id
            }); // 厂区
          });
        });
    },

    // 获取详情
    getDetail() {
      if (String(this.info_id) === "undefined") {
        return false;
      }
      this.$common
        .http({
          url: "/api/queue/emergency/get_booking_detail",
          data: {
            info_id: this.info_id
          }
        })
        .then(res => {
          console.log(res.data.data);
          let obj = res.data.data;
          this.setValue(obj, "detail");
        });
    },

    setValue(obj, tag) {
      this.file.list1 = [];
      this.file.list2 = [];
      this.file.list3 = [];
      this.file.list4 = [];
      this.file.list5 = [];
      this.file.list6 = [];
      this.fileListObj = [];
      this.previewOption.images = [];
      if (tag === "detail") {
        this.proLineColumms = [];
        this.params.proLineSelect = [];
        // 报到状态（state === 2 为已报到，此时禁用修改预约时间）
        this.params.bookingState = obj.state;
        // 业务大类
        this.params.category = obj.category;
        this.params.categoryValue = obj.categor == 1 ? '装车' : '卸货';
        // 厂区
        for (let i = 0; i < this.areaColumns.length; i++) {
          if (this.areaColumns[i].id === obj.com_id) {
            this.params.comId = obj.com_id;
            this.params.areaValue = this.areaColumns[i].text;
          }
        }
        // 运输单位
        this.params.unitName = obj.info.unit;
        // 业务
        for (let i = 0; i < this.rowDataObj.length; i++) {
          if (this.rowDataObj[i].id === obj.com_id) {
            let _newObj = [];
            this.rowDataObj[i].business.forEach(items => {
              _newObj.push({
                text: items.name,
                ...items
              });
            });
            this.businessColumns = _newObj;
          }
        }
        // 业务子类
        for (let i = 0; i < this.businessColumns.length; i++) {
          if (this.businessColumns[i].id === obj.business.id) {
            this.params.businessValue = obj.business.name;
            this.params.businessId = obj.business.id;
            this.businessColumns[i].sub_buness.forEach(item => {
              this.proLineColumms.push({
                id: item.id,
                name: item.name,
                type: item.type,
                selective_type: obj.business.type,
                selected: false
              });
            });
            this.setVehicleTypeColumns(this.businessColumns[i].vehicle_type);
          }
        }
        // 是否单选
        this.businessType = obj.business.type;
        // 业务子类/产品线
        for (let i = 0; i < this.proLineColumms.length; i++) {
          for (let j = 0; j < obj.business_ids.length; j++) {
            if (this.proLineColumms[i].id === obj.business_ids[j]) {
              this.proLineColumms[i].selected = true;
              this.params.proLineSelect.push(this.proLineColumms[i]);
            }
          }
        }
        // 兼容业务被禁用的情况
        if (
          this.params.proLineSelect.length !== obj.business.sub_business.length
        ) {
          this.params.businessValue = obj.business.name;
          this.params.businessId = obj.business.id;
          // 过滤出被禁用的产品线
          let newObj = obj.business.sub_business.filter(
            x => !this.proLineColumms.some(item => x.id === item.id)
          );
          newObj.forEach(item => {
            let forbidObj = {
              id: item.id,
              name: item.name,
              selected: true,
              selective_type: item.type,
              type: item.type
            };
            this.proLineColumms.push(forbidObj);
            this.params.proLineSelect.push(forbidObj);
          });
        }
        // 预约时间
        let time = `${String(obj.booking_day).substring(0, 4)}-${String(
          obj.booking_day
        ).substring(4, 6)}-${String(obj.booking_day).substring(6, 8)}`;
        this.params.instanceId = obj.booking_time_instance_number_id;
        this.params.timeValue = time;
        this.params.begin_time = obj.booking_time.begin_time;
        this.params.end_time = obj.booking_time.end_time;
        // 同时设置日期选择器的值
        this.timePicker.date = time;
        this.timePicker.beginTime = obj.booking_time.begin_time;
        this.timePicker.endTime = obj.booking_time.end_time;
        this.timePicker.instanceId = obj.booking_time_instance_number_id;
        this.getBookingTime(obj.booking_day, "edit");
        // 车辆类型
        this.params.vehicleValue = obj.info.vehicle_type === 0 ? "" : getVehicleTypeLabel(obj.info.vehicle_type);
        this.params.type = obj.business.type;
        this.params.order_code = obj.order_code;
        this.params.delivery_unit = obj.delivery_unit;
      }
      // 车牌
      // 车牌
      if (Number(obj.info.license_plate_type) === 0) {
        this.licenseType = "normal";
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
      }
      if (Number(obj.info.license_plate_type) === 1) {
        this.licenseType = "newEnergy";
        this.isActive1 = false;
        this.isActive2 = true;
        this.isActive3 = false;
      }
      if (Number(obj.info.license_plate_type) === 2) {
        this.licenseType = "HKorMacao";
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = true;
      }
      this.licenseValue = obj.info.license_plate;

      // : this.vehicleColumns[obj.info.vehicle_type - 1];
      // 司机信息
      this.driver.name = obj.info.name;
      this.driver.phone = obj.info.contact;
      this.driver.cardNum = obj.info.id_card;
      // 备注
      this.params.remarks = obj.note;
      // 图片
      // this.fileListObj = obj.file;
      // 附件
      console.log(obj);
      this.params.booking_attach = obj.booking_attach;
      let bookingAttachFile = obj.booking_attach.map((item, index) => {
        return {
          url: item.real_path,
          urlObj: item,
          type: item.type,
          index: index
        }
      });
      this.bookingAttachFileList = bookingAttachFile;
      obj.file.forEach(item => {
        let index = "";
        if (Number(item.type) === 0) {
          index = 0;
        } else if (Number(item.type) === 1) {
          index = 1;
        } else if (Number(item.type) === 4) {
          index = 2;
        } else if (Number(item.type) === 5) {
          index = 3;
        } else if (Number(item.type) === 2) {
          index = 4;
        } else if (Number(item.type) === 3) {
          index = 5;
        }
        item.index = index;
        let newObj = {
          url: item.real_path,
          urlObj: item,
          type: item.type,
          index: item.index
        };
        // this.previewOption.images.splice(item.type, 0, item.real_path);
        console.log(index, item);
        this.fileListObj.splice(item.index, 0, item);
        this.previewOption.images.splice(item.index, 0, item.real_path);
        if (item.type === 0) {
          this.file.list1.push(newObj);
        } else if (item.type === 1) {
          this.file.list2.push(newObj);
        } else if (item.type === 2) {
          this.file.list3.push(newObj);
        } else if (item.type === 3) {
          this.file.list4.push(newObj);
        } else if (item.type === 4) {
          this.file.list5.push(newObj);
        } else if (item.type === 5) {
          this.file.list6.push(newObj);
        }
      });
    },

    // 格式化预约时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 选择预约时间
    async selectAppointTime() {
      this.isDischarge = false;
      if (Number(this.params.bookingState) === 2) {
        this.$common.mbToastFail("司机已报到，预约时间不可修改");
        return false;
      }
      if (this.params.businessId === "") {
        this.$common.mbToastFail("请选择业务");
        return false;
      }
      let bookingDataRes = await this.$common.http({
        url: "/api/queue/emergency/get_booking_data",
        data: {}
      });
      bookingDataRes = bookingDataRes.data.data;
      console.log("bookingDataRes", bookingDataRes);
      let booking_days = [];
      bookingDataRes.forEach(element => {
        if (element.id == this.params.comId) {
          element.business.forEach(item => {
            if (item.id == this.params.businessId) {
              booking_days = item.booking_days;
            }
          });
        }
      });

      if (booking_days.length == 0) {
        this.$common.mbToastFail("当前业务无可预约时间段");
        return false;
      }
      if (booking_days.length > 0) {
        let minDate = booking_days[booking_days.length - 1].toString();
        minDate =
          minDate.slice(0, 4) +
          "/" +
          minDate.slice(4, 6) +
          "/" +
          minDate.slice(6, 8);
        let maxDate = booking_days[0].toString();
        maxDate =
          maxDate.slice(0, 4) +
          "/" +
          maxDate.slice(4, 6) +
          "/" +
          maxDate.slice(6, 8);
        this.minDate = new Date(minDate);
        this.maxDate = new Date(maxDate);
      }

      this.bookingDays = [];
      booking_days.forEach(element => {
        let elementStr = element.toString();
        this.bookingDays.push(
          elementStr.slice(0, 4) +
            "-" +
            elementStr.slice(4, 6) +
            "-" +
            elementStr.slice(6, 8)
        );
      });

      this.$router.push({
        path: "/rhwxEmergeAppointModify/1",
        query: {
          type: this.type,
          info_id: this.info_id,
          id: this.id,
          pageType: this.pageType,
          time1: this.time1,
          time2: this.time2,
          keyword: this.keyword
        }
      });
      this.timePicker.date =
        this.params.timeValue === "" ? "请选择预约时间" : this.params.timeValue;
      this.timePicker.beginTime = this.params.begin_time;
      this.timePicker.endTime = this.params.end_time;
      this.timePicker.instanceId = this.params.instanceId;
      document.title = "选择预约时间";
      // 未按确定键返回时，需重置instanceId
      this.hongtaTime.forEach(item => {
        item.tag = false;
        item.color = "color: #666666";
        // 预约开始时间大于当前时间时可选
        // eslint-disable-next-line no-useless-escape
        let _newdate = this.timePicker.date.replace(/\-/g, "/");
        // 应急预约不需要判断提前预约时间限制
        if (
          new Date(`${_newdate} ${item.begin_time}`).getTime() >
          new Date().getTime()
        ) {
          item.color = "";
        }
        if (item.id === this.timePicker.instanceId) {
          item.tag = true;
        }
      });
      if (this.params.timeValue !== "") {
        let arr = this.timePicker.date.split("-");
        this.getBookingTime(`${arr[0]}${arr[1]}${arr[2]}`, "edit");
      }
      this.showTime = true; // 面板显示
      this.formShow = false;
      if (this.timePicker.date === "请选择预约时间") {
        this.timeShow = true; // 如果选择为空，自动弹出日历选择器
      }
    },

    // 选择预约时间--卸货
    async selectAppointTime2() {
      this.isDischarge = true;
      if (Number(this.params.bookingState) === 2) {
        this.$common.mbToastFail("司机已报到，预约时间不可修改");
        return false;
      }
      if (this.params.dischargeBusinessId === "") {
        this.$common.mbToastFail("请选择业务");
        return false;
      }
      let bookingDataRes = await this.$common.http({
        url: "/api/queue/dispatcher/get_booking_data",
        data: {}
      });
      bookingDataRes = bookingDataRes.data.data;
      console.log("bookingDataRes", bookingDataRes);
      let booking_days = [];
      bookingDataRes.forEach(element => {
        if (element.id == this.params.comId) {
          element.business.forEach(item => {
            if (item.id == this.params.dischargeBusinessId) {
              booking_days = item.booking_days;
            }
          });
        }
      });

      if (booking_days.length == 0) {
        this.$common.mbToastFail("当前业务无可预约时间段");
        return;
      }
      if (booking_days.length > 0) {
        let minDate = booking_days[booking_days.length - 1].toString();
        minDate =
          minDate.slice(0, 4) +
          "/" +
          minDate.slice(4, 6) +
          "/" +
          minDate.slice(6, 8);
        let maxDate = booking_days[0].toString();
        maxDate =
          maxDate.slice(0, 4) +
          "/" +
          maxDate.slice(4, 6) +
          "/" +
          maxDate.slice(6, 8);
        this.minDate = new Date(minDate);
        this.maxDate = new Date(maxDate);
      }

      this.bookingDays = [];
      booking_days.forEach(element => {
        let elementStr = element.toString();
        this.bookingDays.push(
          elementStr.slice(0, 4) +
            "-" +
            elementStr.slice(4, 6) +
            "-" +
            elementStr.slice(6, 8)
        );
      });

      this.$router.push({
        path: "/rhwxAppointModify/1",
        query: {
          type: this.type,
          info_id: this.info_id,
          id: this.id,
          pageType: this.pageType,
          time1: this.time1,
          time2: this.time2,
          keyword: this.keyword
        }
      });
      this.timePicker.date = this.params.dischargeTimeValue === "" ? "请选择预约时间" : this.params.dischargeTimeValue;
      this.timePicker.beginTime = this.params.discharge_begin_time;
      this.timePicker.endTime = this.params.discharge_end_time;
      this.timePicker.instanceId = this.params.dischargeInstanceId;
      document.title = "选择预约时间";
      // 未按确定键返回时，需重置instanceId
      this.hongtaTime.forEach(item => {
        item.tag = false;
        item.color = "color: #666666";
        // eslint-disable-next-line no-useless-escape
        let _newdate = this.timePicker.date.replace(/\-/g, "/");
        if (
          new Date(`${_newdate} ${item.begin_time}`).getTime() >
          (new Date().getTime() / 1000 + item.min_booking_time) * 1000
        ) {
          item.color = "";
        }
        if (item.id === this.timePicker.instanceId) {
          item.tag = true;
        }
      });
      
      if (this.params.dischargeTimeValue !== "") {
        let arr = this.timePicker.date.split("-");
        this.getBookingTime(`${arr[0]}${arr[1]}${arr[2]}`, "edit");
      }
      
      this.showTime = true; // 面板显示
      this.formShow = false;
      if (this.timePicker.date === "请选择预约时间") {
        this.timeShow = true; // 如果选择为空，自动弹出日历选择器
      }
    },

    // 确认选择日期
    onConfirmTime(val) {
      if (moment(val).format("YYYY") === moment().year()) {
        this.timePicker.date = moment(val).format("MM-DD");
      } else {
        this.timePicker.date = moment(val).format("YYYY-MM-DD");
      }
      this.timeShow = false;
      this.hongtaTime = [];
      this.getBookingTime(val);
      this.timePicker.beginTime = "";
      this.timePicker.endTime = "";
      this.timePicker.instanceId = "";
    },

    getBookingTime(val, tag) {
      let day = "";
      // 标识是否是自动填充的时间（编辑 车牌关联信息）
      if (tag === "edit") {
        day = val;
      } else {
        day = moment(val).format("YYYYMMDD");
      }
      let vehicledType = "";
      let key = this.isDischarge ? 'dischargeVehicleValue' : 'vehicleValue';
      console.log(this.params.vehicleValue);
      if (this.params.vehicleValue === "平板车") {
        vehicledType = "flatTruck";
      } else if (this.params[key] === "货柜车") {
        vehicledType = "containerTruck";
      } else if (this.params[key] === "槽罐车") {
        vehicledType = "tankTruck";
      } else if (this.params[key] === "高栏车") {
        vehicledType = "highSidedTruck";
      } else if (this.params[key] === "其他") {
        vehicledType = "orderTruck";
      }
      this.$common
        .http({
          url: "/api/queue/emergency/query_business_time",
          data: {
            booking_day: day,
            business_id: this.isDischarge ? this.params.dischargeBusinessId : this.params.businessId
          }
        })
        .then(res => {
          this.appointTimeSource = res.data.data;
          console.log(this.appointTimeSource);
          this.hongtaTime = [];
          this.appointTimeSource.forEach(item => {
            let obj = {
              begin_time: item.begin_time,
              end_time: item.end_time,
              tag: false,
              id: item.id,
              color: "color: #666666",
              min_booking_time: item.min_booking_time
            };
            console.log(JSON.stringify(item.detail));
            if (JSON.stringify(item.detail) != "[]") {
              // 如果detail不为空（业务=车型号源限制A；车型=平板车）
              // total_number=0：预约上限=0；可预约数=0
              // total_number=-1：预约上限=不限；可预约数=不限
              if (vehicledType) {
                obj.total_number = item.detail[vehicledType].total_number;
                obj.used_number = item.detail[vehicledType].used_number;
              }
              obj.isLimit = true;
            } else {
              obj.total_number = item.total_number;
              obj.used_number = item.used_number;
            }
            // // if (
            //   moment(`${this.timePicker.date} ${item.begin_time}`).unix() >
            //   moment().unix()
            // ) {
            // eslint-disable-next-line no-useless-escape
            let _newdate = this.timePicker.date.replace(/\-/g, "/");
            // 应急预约不需要判断提前预约时间的限制
            if (
              new Date(`${_newdate} ${item.begin_time}`).getTime() >
              new Date().getTime()
            ) {
              obj.color = "";
            }
            this.hongtaTime.push(obj);
            let key_t = this.isDischarge ? 'discharge_multiple_time' : 'multiple_time'
            if (
              this.isMultipleTime &&
              this.params[key_t] &&
              this.params[key_t].length > 0 &&
              this.hongtaTime.length > 0
            ) {
              this.hongtaTime.map(el => {
                if (this.params[key_t].some(e => e.instanceId == el.id)) {
                  el.tag = true;
                  return;
                } else {
                  el.tag = false;
                  return;
                }
              });
            }
          });
          if (tag === "edit" && !this.isMultipleTime) {
            this.hongtaTime.forEach(item => {
              if (item.id === this.timePicker.instanceId) {
                item.tag = true;
                item.color = "";
              }
            });
          }
        });
    },

    // 选择预约时间段
    changeAppointTime(item) {
      if (item.name === "") {
        return false;
      }
      if (item.color !== "") {
        this.$common.mbToastFail(
          `此业务需提前${parseFloat(
            (item.min_booking_time / 60 / 60).toFixed(2)
          )}小时发起预约，该时间段不可预约`
        );
        return false;
      }
      if (!this.isMultipleTime) {
        let arr = [];
        arr = this.hongtaTime;
        for (let i = 0; i < arr.length; i++) {
          arr[i].tag = false;
          // arr[i].color = "color: #666666";
        }
        item.tag = true;
        this.timePicker.instanceId = item.id;
        this.timePicker.beginTime = item.begin_time;
        this.timePicker.endTime = item.end_time;
        console.log(item);
      } else {
        let select = [];

        if (item.tag) {
          item.tag = false;
        } else {
          item.tag = true;
        }
        this.timePicker.instanceId = item.id;
        this.timePicker.beginTime = item.begin_time;
        this.timePicker.endTime = item.end_time;
        let arr = [];
        arr = this.hongtaTime;
        arr.map(item => {
          if (item.tag) {
            select.push({
              instanceId: item.id,
              beginTime: item.begin_time,
              endTime: item.end_time
            });
          }
        });
        console.log(select);
        this.params.multiple_time = select;
      }
    },

    // 格式化日历显示
    formatter(day) {
      if (day.type === "start") {
        day.bottomInfo = "";
      } else if (day.type === "end") {
        day.bottomInfo = "";
      } else {
        day.bottomInfo = "";
      }
      if (this.bookingDays.indexOf(moment(day.date).format("YYYY-MM-DD")) < 0) {
        day.type = "disabled";
      }
      return day;
    },

    // 快捷选择日期
    setTime() {
      let end = new Date();
      this.timePicker.date = moment(end).format("YYYY-MM-DD");
      this.timeShow = false;
      this.getBookingTime(this.timePicker.date);
    },

    // 确认选择预约时间
    saveTime() {
      // this.showTime = false;
      if (this.timePicker.instanceId === "") {
        this.$common.mbToastFail("请选择预约时间段");
        return false;
      }
      if (!this.isDischarge) {
        this.params.timeValue = this.timePicker.date;
        this.params.begin_time = this.timePicker.beginTime;
        this.params.end_time = this.timePicker.endTime;
        this.params.instanceId = this.timePicker.instanceId;
      } else {
        this.params.dischargeTimeValue = this.timePicker.date;
        this.params.discharge_begin_time = this.timePicker.beginTime;
        this.params.discharge_end_time = this.timePicker.endTime;
        this.params.dischargeInstanceId = this.timePicker.instanceId;
      }
      this.$router.push({
        path: "/rhwxEmergeAppointModify/0",
        query: {
          type: this.type,
          info_id: this.info_id,
          id: this.id,
          pageType: this.pageType,
          time1: this.time1,
          time2: this.time2,
          keyword: this.keyword
        }
      });
      this.showTime = false;
      this.formShow = true;
    },

    // 拍照指引
    toPhotoGuide() {
      this.$router.push({
        path: "/rhwxPhotoGuide"
      });
    },

    // 清空司机信息
    clearDriverInfo() {
      // 基本信息
      for (let key in this.driver) {
        this.driver[key] = "";
      }
      // 身份证照片 驾驶证照片
      this.file.list1 = [];
      this.file.list2 = [];
      this.file.list5 = [];
      this.file.list6 = [];
      let arrA = [];
      let previewA = [];
      this.fileListObj.forEach(item => {
        if (
          Number(item.type === 0) ||
          Number(item.type === 1) ||
          Number(item.type === 4) ||
          Number(item.type === 5)
        ) {
          arrA.push(item);
          previewA.push(item.real_path);
        }
      });
      // 更新file对象
      let arrB = this.fileListObj.filter(
        x => !arrA.some(item => x.type === item.type)
      );
      // 更新预览对象
      let previewB = this.previewOption.images.filter(
        x => !previewA.some(item => x === item)
      );
      this.fileListObj = arrB;
      this.previewOption.images = previewB;
    },

    // 点击取消
    goBack() {
      window.clearInterval(this.appointEmergeModifyInterval);
      this.appointEmergeModifyInterval = null;
      // if (this.type === "edit") {
      //   localStorage.removeItem("appointEmergeModify");
      // }
      if (this.pageType === "list") {
        this.$router.push({
          path: "/rhwxEmergeAppointList",
          query: {
            time1: this.time1,
            time2: this.time2,
            keyword: this.keyword
          }
        });
      } else if (this.pageType === "detail") {
        this.$router.push({
          path: "/rhwxEmergeAppointDetail",
          query: {
            id: this.id,
            info_id: this.info_id,
            time1: this.time1,
            time2: this.time2,
            keyword: this.keyword
          }
        });
      } else if (this.pageType === "add") {
        this.$router.push({
          path: "/rhwxEmergeAppointAdd",
          query: {
            time1: this.time1,
            time2: this.time2,
            keyword: this.keyword
          }
        });
      }
    }
  },
  created() {
    if (String(this.type) === "add") {
      document.title = "添加预约信息";
    } else {
      document.title = "编辑预约信息";
    }
  },
  computed: {
    type() {
      return this.$route.query.type || 0;
    },
    pageType() {
      return this.$route.query.pageType;
    },
    info_id() {
      return this.$route.query.info_id;
    },
    id() {
      return this.$route.query.id;
    },
    time1() {
      return this.$route.query.time1;
    },
    time2() {
      return this.$route.query.time2;
    },
    keyword() {
      return this.$route.query.keyword;
    },
    tDayCanSelct() {
      if (this.bookingDays.indexOf(moment().format("YYYY-MM-DD")) < 0) {
        return false;
      } else {
        return true;
      }
    },
    isMultipleTime() {
      let rt = false;
      //业务类型为自定义类型时 支持时间多选(只有新建时支持多选)
      if (this.type == "add") {
        rt = (this.params.category == 1 || this.params.category == 2) && (this.params.type == 0 || this.params.type == 3);
      }
      return rt;
    },
    businessColumnsComputed() {
      if (this.params.category == 3 || this.params.category == 1) {
        this.businessColumns.map((e) => {
          console.log(e, e.category)
        })
        return this.businessColumns.filter(e => e.category == 1)
      } else {
        return this.businessColumns.filter(e => e.category == 2)
      }
    }
  },
  destroy() {
    window.clearInterval(this.appointEmergeModifyInterval);
    this.appointEmergeModifyInterval = null;
    // localStorage.removeItem("appointEmergeModify");
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.appointDiv-modify {
  min-height: calc(100vh - 1px);
  border-top: 1px solid #f4f5f6;
  background: #f4f5f6;
  font-size: 16px;
  .cont1 {
    line-height: 54px;
    background: #fff;
    // font-size: 14px;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
    }
  }
  .cont2 {
    padding: 20px 16px;
    background: #fff;
    margin-bottom: 10px;
    .tabblk-active {
      display: inline-block;
      background: #00c8d2;
      color: #fff;
      margin: 14px 20px 0px 0px;
      padding: 6px 11px;
      border-radius: 20px;
    }
    .tabblk {
      display: inline-block;
      background: #f7f7f7;
      color: #999999;
      margin: 14px 20px 0px 0px;
      padding: 6px 11px;
      border-radius: 20px;
    }
  }
  .cont3 {
    padding: 16px;
    background: #fff;
    margin-bottom: 10px;
    .car-license {
      &-title {
        margin: 4px 0px 20px;
        font-size: 17px;
      }
      &-btn-active {
        display: inline-block;
        background: #00c8d2;
        color: white;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 14px 24px 0px;
      }
      &-btn {
        display: inline-block;
        background: #f6f6f7;
        color: #00c8d2;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 14px 24px 0px;
      }
    }
  }
  .cont4 {
    margin-bottom: 10px;
  }

  .cont5 {
    background: #fff;
    margin-bottom: 10px;
    padding: 16px;
    font-size: 18px;
  }

  .cont6 {
    background: #fff;
    padding: 16px 0px;
  }

  .cont7 {
    display: flex;
    justify-content: center;
    font-size: 13px;
    color: #008b5e;
    text-align: center;
    margin-bottom: 10px;
    & > div {
      flex: 1;
    }
    &-btn {
      background: #cce8df;
      border-radius: 4px;
      display: inline-block;
      padding: 7px 21px;
    }
  }
}
.timeDiv {
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: #f4f5f6;
  font-size: 16px;
  .cont1 {
    line-height: 56px;
    background: #fff;
    font-size: 14px;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    height: 56px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
      font-size: 20px;
    }
  }
  .cont2 {
    background: #fff;
    display: flex;
    font-size: 18px;
    padding: 16px;
    align-items: center;
    &-first {
      width: calc(100vw - 216px) !important;
      // flex: 1.1 !important;
      text-align: left !important;
    }
    & > div {
      // flex: 1;
      width: 97px;
      text-align: center;
      margin-right: 13px;
    }
  }
  .cont3 {
    background: #fff;
    display: flex;
    padding: 0px 16px 20px;
    align-items: center;
    // line-height: 43px;
    padding: 0px 16px;
    height: 43px;
    &-first {
      flex: 1.1;
      text-align: left !important;
      word-break: break-all;
    }
    &-second {
      color: #ec3f67;
      width: 97px;
      text-align: center;
    }
    &-third {
      color: #008b5e;
      width: 97px;
      text-align: center;
    }
    &-forth {
      width: 16px;
      text-align: center;
    }
  }
  .pd40 {
    padding-bottom: 36px;
  }
  .bg456 {
    background: #f4f5f6;
  }
  .calendar-cont {
    height: 36px;
    font-size: 14px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #009967;
    background: #f7f7f7;
    box-shadow: 0px 2px 20px rgba(125, 126, 128, 0.16);
  }

.mid-cont {
  background: #fff;
  margin-top: 10px;
  padding: 16px;
  font-size: 18px;
  color: #000000;
  line-height: 18px;
}
}
.mainDiv {
  background: #fff;
}
</style>
<style lang="less">
.appointDiv-modify {
  .van-cell {
    font-size: 16px;
  }
  .van-field__label {
    color: #000;
  }
  .van-button--round {
    border-radius: 4px;
  }
  .van-calendar__popup.van-popup--bottom,
  .van-calendar__popup.van-popup--top {
    height: 71%;
  }


  .van-uploader__preview {
    margin: 0px;
    width: 100%;
  }
  .van-uploader__preview-image {
    width: inherit;
    height: inherit;
    object-fit: cover;
    vertical-align: top;
    // width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
    border-radius: 2px;
  }
  .fileForm {
    .van-uploader__wrapper {
      row-gap: 10px;
      column-gap: 10px;
    }

    .van-uploader__input-wrapper {
      width: calc(calc(100% - 10px) / 2);
    }

    .van-uploader__preview {
      margin: 0px;
      width: calc(calc(100% - 10px) / 2);
    }
    .van-uploader__preview-image {
      // width: inherit;
      // height: inherit;
      width: 100%;
      height: calc((100vw - 42px) / 3.4);
      object-fit: contain;
      vertical-align: top;
      object-position: center;
      // width: calc((100vw - 42px) / 2);
      // height: calc((100vw - 42px) / 3.4);
      border-radius: 2px;
      border: 1px solid #eeeeee;
    }
  }
  .van-button--round {
    border-radius: 4px;
  }
  .van-image__error,
  .van-image__img,
  .van-image__loading {
    width: 100%;
  }
  .van-uploader {
    width: 100%;
  }
  .van-uploader__input-wrapper {
    width: 100%;
  }
  .van-uploader__preview-delete-icon {
    font-size: 27px;
  }
  .van-uploader__preview-delete {
    border-radius: 0 2px 0 27px !important;
  }
  .van-uploader__preview-delete {
    width: 27px;
    height: 27px;
    background-color: red;
  }
  .card-img-div {
    color: #999999;
    font-size: 14px;
    background: #f4f5f6;
    display: inline-block;
    object-fit: cover;
    // width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
    width: 100%;
    vertical-align: text-bottom;
    border-radius: 2px;
    &-icon {
      text-align: center;
      top: 50%;
      position: relative;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .card-img {
    object-fit: cover;
    vertical-align: top;
    // width: calc((100vw - 42px) / 2);
    // height: calc((100vw - 42px) / 3.4);
  }
}
#appointEmergeModify {
  #appointEmergeModifyCal .van-calendar__popup.van-popup--left,
  .van-calendar__popup.van-popup--right {
    height: 460px;
    margin: 0px 30px;
    // right: 50%;
    // transform: translate3d(50%, -50%, 0);
  }
  #appointEmergeModifyCal .van-calendar__footer {
    padding: 0px;
  }
}
</style>
